<ion-row *ngIf="isEmployee$ | async">
  <ion-col size="2">
    <ion-icon name="pricetag-outline"></ion-icon>
  </ion-col>
  <ion-col size="10">
    {{ 'available.employee.discount' | translate}}: <eva-price [price]="availableDiscount$ | async"></eva-price>
  </ion-col>
</ion-row>
